import { render, staticRenderFns } from "./SpecimenCopyAddressCard.vue?vue&type=template&id=32624e4d&lang=pug"
import script from "./SpecimenCopyAddressCard.vue?vue&type=script&lang=js"
export * from "./SpecimenCopyAddressCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports